import React, { Component } from 'react';

import {
    Link
} from "react-router-dom";
import PatientMenu from './includes/PatientMenu';
import PatientPageHeader from './includes/PatientPageHeader';
import { _logOut, _getLoginStatus, _showOverlay, _hideOverlay, FILE_URL, _getLocalLanguage, _setLocationCookie, _getLocationCookie } from './includes/Constants';
import withNavigateHook from './includes/withNavigateHook';
import { _getAllDoctor, _getPatientHistory, _getPatientPrescriptions } from './api/Patient';
import Toast from './includes/Toast';
import Loader from './includes/Loader';
import { lang_en } from './includes/language/en';
import { lang_hi } from './includes/language/hi';
import { _getCities } from './api/Common';
const language = _getLocalLanguage();


class PatientPrescriptions extends Component {
    /**
     * 
     * @param {*} props 
     */
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            list: [],
            message: '',
            type: '',
            visibility: 'hide',
            loader: "hide",
            text_language: language.lang == 'en' ? lang_en : lang_hi,
        }

    }


    /**
    * 
    * @returns 
    */
    componentDidMount = async () => {
        let res = await _getLoginStatus();
        // console.log(res.status);
        if (res['status'] == true) {
            let location = await _getCities();
            await this.setState({
                user: res.data,
                location_list: location.data.result
            });

            if (res['data']['user_type'] == 'Patient') {
                let res1 = await _getPatientPrescriptions(res.data.id);
                if (res1.data.response == "success") {

                    this.setState({
                        list: res1.data.result,
                        loader: "hide",
                    });
                    // _hideOverlay();
                } else {
                    this.setState({
                        list: [],
                        message: res1.data.error,
                        type: 'error',
                        visibility: 'show',
                        loader: "hide"
                    });
                    // _hideOverlay();
                }
            } else {
                this.props.navigation('/home');
            }

        } else {
            this.props.navigation('/home');
        }
    }



    /**
      *
      */
    _getBookingList = () => {
        let total_counter = 0;
        // console.log(this.state.list);
        if (Object.keys(this.state.list).length > 0) {
            return (
                Object.values(this.state.list).map((value, index) => {
                    total_counter = total_counter + 1;
                    return (

                        <div key={"div-" + index} className="card-panel grey lighten-5 z-depth-1">
                            <div className="row valign-wrapper">

                                {/* <div className="col s3">
                         <img src="images/img3.png" alt="" className="circle responsive-img img-50" />
                    </div> */}

                                <div className="col s12 ">
                                    {
                                        <span className="black-text p-20">
                                            <p className="black-text pl-20"><b>Sr. No:</b>&nbsp;{total_counter}</p>
                                            <p className="black-text pl-20"><b>{this.state.text_language[0].appointment_text} {this.state.text_language[0].date_text}:</b>&nbsp;{value.booking_date}</p>

                                            <p className="black-text pl-20"><b>{this.state.text_language[0].slot_text}:</b>&nbsp;{typeof value.slot != "undefined" && value.slot != '00:00' ? value.slot : 'Pending'}</p>
                                            <p className="black-text pl-20"><b>{this.state.text_language[0].doctor_text} {this.state.text_language[0].name_text}:</b>&nbsp;{value.doctor.first_name + " " + value.doctor.last_name}</p>
                                            <p className="black-text pl-20"><b>{this.state.text_language[0].patient_text} {this.state.text_language[0].name_text}:</b>&nbsp;{value.patient_history.patient_details.name}</p>
                                            <p className="black-text pl-20"><b>{this.state.text_language[0].age_text}:</b>&nbsp;{value.patient_history.patient_details.age}&nbsp;years</p>
                                            {/* <p className="black-text pl-20"><b>{this.state.text_language[0].booking_text} {this.state.text_language[0].on_text}:</b>&nbsp;{value.booking_date}</p> */}
                                            <p className="black-text pl-20"><b>{this.state.text_language[0].status_text}:</b>&nbsp;{value.status}</p>
                                            <p className="black-text pl-20"><b>{this.state.text_language[0].booking_text} {this.state.text_language[0].number_text}:</b>&nbsp;{typeof value.booking_number != "undefined" && value.booking_number != 0 ? value.booking_number : 'Not Assingned at the moment.'}</p>
                                            {
                                                typeof value.patient_history.priscription_image != null && value.patient_history.priscription_image != ""
                                                    ? <p><b>Priscription Image:</b><br />
                                                        <div className="dp-div pt-10">
                                                            <img src={FILE_URL + value.patient_history.priscription_image} alt="" className="responsive-img" />

                                                        </div>

                                                    </p>
                                                    :
                                                    ""
                                            }
                                        </span>
                                    }


                                </div>


                            </div>

                        </div>
                    )



                })
            )
        } else {
            return (

                <div className="col s12 center-align mt-20">
                    <img src="images/not-found.gif" alt="" className="circle responsive-img" />

                </div>



            )
        }

    }




    render() {
        return (
            <React.Fragment>
                {/* <PatientHeader /> */}
                <Loader visibility={this.state.loader} />
                <PatientPageHeader />
                <main role="main">

                    <section id="dashboard-page" className="oparcheecommonCode">

                        <div className="dashboardContent">

                            <div className="container">
                                <div className="row">
                                    <div className="col s12 mt-10">
                                        <div className="strip">

                                            <div className="row pt-20">

                                                <div className="col s3 left-align">


                                                </div>

                                                <div className="col s6 center-align">

                                                    <div className="bookingTxt"><h3>
                                                        <span>{this.state.text_language[0].prescription_text} {this.state.text_language[0].history_text}</span></h3>
                                                    </div>
                                                </div>
                                                <div className="col s3 right-align">


                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                    <div className="col s12">
                                        {this._getBookingList()}
                                    </div>

                                </div>

                            </div>

                        </div>

                    </section>

                </main>
                <PatientMenu />
                {
                    this.state.visibility == 'show'
                        ?
                        <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} />
                        :
                        ''
                }
                {/* <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} /> */}
            </React.Fragment>
        );
    }
}

export default withNavigateHook(PatientPrescriptions);
